/** Alias for clarity */
export type UnixTimestampMs = number

export const applicationIds = ['eat', 'playtime', 'q12', 'portal', 'url_shortener'] as const

export type ApplicationId = (typeof applicationIds)[number]

export const applicationRoles = ['admin', 'manager', 'user'] as const

export type ApplicationRole = (typeof applicationRoles)[number]

export const userRoles = ['admin', 'user'] as const

export type UserRole = (typeof userRoles)[number]

export const applicationRoleRank: Record<ApplicationRole, number> = {
    user: 1,
    manager: 2,
    admin: 3,
}

// Only Q12 has a working manager role (read-only dashboard/results access);
// for every other application manager gates nothing, so it is not assignable.
export const assignableApplicationRoles = (
    applicationId: ApplicationId,
): readonly ApplicationRole[] =>
    applicationRoles.filter((role) => role !== 'manager' || applicationId === 'q12')

export const applicationLabels: Record<ApplicationId, string> = {
    eat: 'gotoAndEat',
    playtime: 'Badges',

    q12: 'Q12',
    portal: 'Portal',
    url_shortener: 'URL Shortener',
}
